import React, { useRef, useState, useEffect } from 'react';

import LabelSelector from './LabelSelector';
import { focusRef, blurRef } from '../shared/EventHelpers';

const noLabel = {
    name: 'Ingen',
    color: '#5d6d7',
};

const EditSelectLabel = ({ value, setValue, options, onSave, isInvalid, showLabelIcon, autoFocus, handleCancel }) => {
    const inputRef = useRef();
    const [showOptions, setShowOptions] = useState(!!autoFocus);

    const onClick = () => {
        setShowOptions(!showOptions);
    };

    useEffect(() => {
        showOptions && focusRef(inputRef);
    }, [showOptions]);

    useEffect(() => {
        !showOptions && blurRef(inputRef);
    }, [showOptions]);

    useEffect(() => {
        autoFocus && focusRef(inputRef);
    }, [autoFocus]);

    const optionsWithNone = options && options.length ? [noLabel].concat(options) : null;

    return (
        <div className='crm-editable-field-wrapper'>
            <div className={`input-wrapper select-label-wrapper ${isInvalid ? 'invalid' : ''}`} onMouseDown={onClick}>
                <LabelSelector
                    {...{ value, setValue, showOptions, setShowOptions, inputRef, onSave, autoFocus, showLabelIcon, handleCancel }}
                    options={optionsWithNone}
                />
            </div>
        </div>
    );
};

export default EditSelectLabel;
